/**
 * Lazy loader for the web-call client stack.
 *
 * LiveKit is the only web-interview path. LiveKitWebClient statically imports
 * livekit-client, which dominates the /web-interview entry chunk. Dynamic
 * import() keeps that stack out of the initial bundle; preloadCallClient warms
 * it on the precall screen.
 *
 * Always import the transport module (not the services/ re-export) so the
 * livekit-client dependency stays behind this dynamic boundary.
 */
import type { CallClient } from '../callClientTypes';

export function isLiveKitCallSoftware(
  callSoftware: string | null | undefined
): boolean {
  return !callSoftware || callSoftware.toUpperCase() === 'LIVEKIT';
}

/** Fire-and-forget warm-up; createCallClient performs the real (cached) import. */
export function preloadCallClient(): void {
  void import('../call/transport/LiveKitWebClient').catch(() => {
    // swallow-ok: This is only transport warm-up; createCallClient awaits a fresh import and CallRuntime handles its retry/failure state.
  });
}

export async function createCallClient(
  livekitUrl: string | null | undefined
): Promise<CallClient> {
  const { LiveKitWebClient } = await import(
    '../call/transport/LiveKitWebClient'
  );
  return new LiveKitWebClient(livekitUrl || '');
}
